import React from 'react';
import { Building2, Home, Building } from 'lucide-react';
import { PropertyType } from '../../../types/estimation';

interface PropertyTypeSelectProps {
  value: PropertyType;
  onChange: (type: PropertyType) => void;
}

export const PropertyTypeSelect: React.FC<PropertyTypeSelectProps> = ({ value, onChange }) => {
  return (
    <div>
      <label className="block text-sm font-medium text-neutral-700 mb-2">
        Type de bien <span className="text-red-500">*</span>
      </label>
      <div className="grid grid-cols-3 gap-4">
        <PropertyCard
          icon={<Building2 className="h-8 w-8" />}
          type="apartment"
          label="Appartement"
          selected={value === 'apartment'}
          onClick={() => onChange('apartment')}
        />
        <PropertyCard
          icon={<Home className="h-8 w-8" />}
          type="house"
          label="Maison"
          selected={value === 'house'}
          onClick={() => onChange('house')}
        />
        <PropertyCard
          icon={<Building className="h-8 w-8" />}
          type="building"
          label="Immeuble ou division"
          selected={value === 'building'}
          onClick={() => onChange('building')}
        />
      </div>
    </div>
  );
};

const PropertyCard = ({
  icon,
  type,
  label,
  selected,
  onClick,
}: {
  icon: React.ReactNode;
  type: string;
  label: string;
  selected: boolean;
  onClick: () => void;
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`
      card flex flex-col items-center p-6 transition-all
      ${selected ? 'ring-2 ring-primary bg-primary/5' : 'hover:bg-neutral-50'}
    `}
  >
    <div className={`mb-4 ${selected ? 'text-primary' : 'text-neutral-600'}`}>
      {icon}
    </div>
    <span className={`font-medium ${selected ? 'text-primary' : 'text-neutral-700'}`}>
      {label}
    </span>
  </button>
);

export default PropertyTypeSelect;